import { CircularProgress, MuiThemeProvider, createTheme } from "@material-ui/core";
import qs from "query-string";
import { flattenDeep, uniqBy } from "lodash";
import React, { useEffect, useState } from "react";
import { Route, useLocation, withRouter } from "react-router-dom";
import { AnimatedSwitch } from "react-router-transition";
import "./App.scss";
import AppTitle from "./components/AppTitle";
import DescriptionModal from "./components/DescriptionModal";
import LanguageModal from "./components/LanguageModal";
import NavBar from "./components/NavBar";
import PublicMessage from "./components/PublicMessage";
import PublicNotice from "./components/PublicNotice";
import CombineOriginEta from "./containers/CombinedOriginEta";
import Home from "./containers/Home";
import RNHome from "./containers/RNHome";
import Eta from "./containers/Eta";
import RNEta from "./containers/RNEta";
import Schedule from "./containers/Schedule";
import Constants from "./utils/constants";

import {
  getRouteInfo,
  getRouteStops,
  getSetting,
  getRouteNetwork,
} from "./utils/api";

import useGoogleAnalytics from "./utils/hook";
import moment from "moment";

const { LANGUAGES } = Constants;
const { routesTitle } = LANGUAGES;

// const useQuery = (qs) => {
//   console.log("useQuery qs", qs);
//   return new URLSearchParams(qs);
// };

const query = new URLSearchParams(window.location.search);
const fromEClass = query.get("source") === "eclass";

const App = (props) => {
  const supportedLanguages = ["en", "zh", "cn"];
  const { LANGUAGES } = Constants;
  const [routes, setRoutes] = useState([]);
  // const [routesStops, setRoutesStops] = useState([]);
  const [courtName, setCourtName] = useState(null);
  const [currentTitle, setCurrentTitle] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showLangModal, setShowLangModal] = useState(false);
  const [message, setMessage] = useState(null);
  const { court } = props.match.params;
  const location = useLocation();
  const { pathname, search } = location;
  const { site, lang = "zh" } = qs.parse(location.search);

  const [rmbCourtSite, setRmbCourtSite] = useState({
    court: "rmb",
    site: null,
  });
  const [routeNetwork, setRouteNetwork] = useState([]);

  // Settings
  const [showLang, setShowLang] = useState(false);
  const [displayType, setDisplayType] = useState(null);
  // set the hide stop method in Eta Page, orignated from RA Hide Last Stop Eta
  const [hideStop, setHideStop] = useState(null);
  // set traffic message display method
  const [trafficMessage, setTrafficMessage] = useState(null);
  // set eta display method
  const [etaDisplayMethod, setEtaDisplayMethod] = useState(null);
  const [displayRouteCode, setDisplayRouteCode] = useState(false);
  // const [displayVehicleLocation, setDisplayVehicleLocation] = useState(false);
  const [publicMessage, setPublicMessage] = useState(null);
  const [firstStopEtaRoutes, setFirstStopEtaRoutes] = useState([]);
  const [fakeCircularRoutes, setFakeCircularRoutes] = useState([]);
  const [overrideDepartureTimeRoutes, setOverrideDepartureTimeRoutes] =
    useState([]);
  const [overrideAppTitle, setOverrideAppTitle] = useState(null);
  const [vehicleLocationAlwaysShow, setVehicleLocationAlwaysShow] =
    useState(false);
  const [extraInstruction, setExtraInstruction] = useState(null);
  const [vehicleIconBearing, setVehicleIconBearing] = useState(false);
  const [showLicensePlate, setShowLicensePlate] = useState(false);
  const [showLicensePlateOnMap, setShowLicensePlateOnMap] = useState(false);
  const [isTodayHoliday, setIsTodayHoliday] = useState(false);
  const [vehicleColor, setVehicleColor] = useState(false);
  const [stopColor, setStopColor] = useState(false);
  const [themeColour, setThemeColour] = useState("#39F");
  const [theme, setTheme] = useState(null);
  const [hideSchedulePage, setHideSchedulePage] = useState(false);

  useGoogleAnalytics();

  useEffect(() => {
    const getData = async () => {
      try {
        if (!site) {
          setRmbCourtSite({ court: "rmb", site: court });
        }
        const setting = site
          ? await getSetting(court, site)
          : await getSetting("rmb", court);
        if (!setting) {
          console.log("setting", setting);
          props.history.replace("404");
        } else {
          /**
           * displayType: The display style in "Home" page
           * allStops, - display all stops eta
           * firstStop, - only display first stop [e.g. DC]
           * headTailStops , - display the first and last stop
           * noStop, - only display route name (from "where" to "where") [e.g. Royal Ascot]
           * combineStops - combine stops [e.g. kwah]
           * routeNetwork - minibusEasy like routeNetwork [e.g. HKJC]
           * noETA - only show GPS
           * ra - old eta system, annoying client
           */
          setDisplayType(setting?.display_type);
          // localStorage.setItem("displayType", setting?.display_type);

          setStopColor(setting?.stop_colors);
          setVehicleColor(setting?.vehicle_colors);
          {
            console.log("vehicleColor", setting?.vehicle_colors);
            console.log("stopColor", setting?.stop_colors);
          }

          /**
           * tailStops, - hide last stop eta card on Eta Page (not related on Home)
           */
          setHideStop(setting?.hide_stop);

          /**
           * Traffic Message Display Method
           */
          setTrafficMessage(setting?.traffic_message);

          /**
           * Eta Display method for eta card
           */
          setEtaDisplayMethod(setting?.eta_display_method);

          /**
           * displayRouteCode
           */
          setDisplayRouteCode(setting?.route_code_public);
          setCourtName({
            zh: setting.title_tc,
            cn: setting.title_sc,
            en: setting.title_en,
          });
          /**
           * showLang - display language button
           */
          setShowLang(setting?.language_btn);
          setPublicMessage(setting?.publicMessage);
          /**
           * firstStopEtaRoutes - use another route seq last stop eta as first stop eta
           */
          setFirstStopEtaRoutes(setting?.first_stop_eta_routes);
          /**
           * fakeCircularRoutes - similar to combineStops = add another direction laststop to outbound's laststop
           */
          setFakeCircularRoutes(setting?.fake_circular_routes);
          /**
           * showLicensePlate - Show license plate on ETA list
           */
          setShowLicensePlate(setting?.show_license_plate);

          setShowLicensePlateOnMap(setting?.show_license_plate_on_map);

          /**
           * overrideAppTitle - e.g. SV
           */
          if (setting?.override_app_title) {
            const rawOverrideAppTitle = setting?.override_app_title.split("|");
            setOverrideAppTitle({
              zh: rawOverrideAppTitle[0],
              en: rawOverrideAppTitle[1],
              cn: rawOverrideAppTitle[2],
            });
          }
          /**
           * vehicleLocationAlwaysShow e.g. HV
           */
          setVehicleLocationAlwaysShow(setting?.vehicle_location_always_show);
          /**
           * extra_instruction - extra text in description modal
           */
          if (setting?.extra_instruction) {
            const rawExtraInstruction = setting?.extra_instruction.split("|");
            setExtraInstruction({
              zh: rawExtraInstruction[0],
              en: rawExtraInstruction[1],
              cn: rawExtraInstruction[2],
            });
          }
          /**
           * override_departure_time_routes
           * - replace first station eta with another direction last stops eta
           * if the latter time is longer than the former one.
           */
          setOverrideDepartureTimeRoutes(
            setting?.override_departure_time_routes
          );
          /**
           * VehicleIconBearing e.g. BH,
           * - currently only available for vehicle location always show
           */
          setVehicleIconBearing(setting?.vehicle_icon_bearing);
          /**
           * IsTodayHoliday
           * - use 1823 to get hoilday list
           * - get value from redis
           */
          setIsTodayHoliday(setting?.is_today_holiday);

          setHideSchedulePage(setting?.hide_schedule_page);

          const tempRoutes = setting?.display_routes;
          const routes = await Promise.all(
            tempRoutes.map((tempRoute) => getRouteInfo(tempRoute))
          );
          if (!routes || routes.length === 0) {
            props.history.replace("404");
            return;
          } else {
            /**
             * routeNetwork will fetch another set of eta info, will use containers RNEta and RNHome
             */
            if (setting?.display_type === "routeNetwork") {
              const routeCodeSeq = uniqBy(
                flattenDeep(
                  routes.map((el) => {
                    return el.directions.map((ele) => ({
                      routeCode: el.route_code,
                      routeSeq: ele.route_seq,
                    }));
                  })
                ),
                (el) => {
                  return `${el.routeCode}${el.routeSeq}`;
                }
              );

              if (routeCodeSeq.length > 0) {
                const tempRouteNetwork = await Promise.all(
                  routeCodeSeq.map(async (route) => {
                    const tempRN = await getRouteNetwork(
                      route.routeCode,
                      route.routeSeq
                    );
                    const tempRouteStops = await getRouteStops(
                      tempRN.normalRouteId,
                      route.routeSeq
                    );

                    return {
                      ...tempRN,
                      ...tempRouteStops,
                      normalRouteDirection: routes
                        .find((el) => el.route_id === tempRN.normalRouteId)
                        .directions.find(
                          (el) => el.route_seq === route.routeSeq
                        ),
                      routeSeq: route.routeSeq,
                      routeCode: route.routeCode,
                    };
                  })
                );

                setRouteNetwork(tempRouteNetwork);
              }
            }

            const results = await Promise.all(
              routes.map(async (route) => {
                return {
                  ...route,
                  routeStops: await Promise.all(
                    route.directions.map(async (origin) => {
                      const tempResult = await getRouteStops(
                        route.route_id,
                        origin.route_seq
                      );
                      return tempResult.route_stops;
                    })
                  ),
                };
              })
            );
            setRoutes(results);
          }

          setThemeColour(setting?.theme_colour || themeColour);
        }
      } catch (err) {
        console.log("err", err);
        props.history.replace("404");
        return;
      }
    };

    if (!location.pathname.includes("404")) {
      getData();
    }
  }, [court, location.pathname, props, site]);

  useEffect(() => {
    if (location.search) {
      if (!supportedLanguages.includes(lang)) {
        const userLanguage = window.navigator.language.slice(0, 2);
        let newSearch = [];
        if (location.search) {
          newSearch = location.search
            .split("?")[1]
            .split("&")
            .filter((ele) => !ele.includes("lang"));
          newSearch.push(`lang=${userLanguage}`);
          props.history.push(`${location.pathname}?${newSearch.join("&")}`);
        }
      }
    }
  }, [lang, location, props.history, supportedLanguages]);

  useEffect(() => {
    setTheme(createTheme({
      palette: {
        primary: {
          main: themeColour
        }
      }
    }));
  }, [themeColour]);

  useEffect(() => {
    if (publicMessage) {
      const result =
        {
          zh: publicMessage?.message,
          cn: publicMessage?.messageCn,
          en: publicMessage?.messageEn,
        }[lang] || publicMessage?.message;
      if (result && moment().diff(moment(publicMessage.expiry)) < 0) {
        setMessage(result);
      } else {
        setMessage(null);
      }
    } else {
      setMessage(null);
    }
  }, [lang, publicMessage]);

  const redirectToHome = () => {
    setCurrentTitle(null);
    rmbCourtSite.site
      ? props.history.push(`/${rmbCourtSite.site}?lang=${lang}`)
      : props.history.push(`/${court}?site=${site}&lang=${lang}`);
  };

  const redirectToEta = (routeId, routeSeq) => {
    rmbCourtSite.site
      ? props.history.push(
          `/${rmbCourtSite.site}/eta/${routeId}/${routeSeq}?lang=${lang}`
        )
      : props.history.push(
          `/${court}/eta/${routeId}/${routeSeq}?site=${site}&lang=${lang}`
        );
  };

  const navBarGoToPage = (url) => {
    setCurrentTitle(null);
    if (url !== props.history.location.pathname) {
      rmbCourtSite.site
        ? props.history.push(`/${rmbCourtSite.site}${url}?lang=${lang}`)
        : props.history.push(`/${court}${url}?site=${site}&lang=${lang}`);
    }
  };

  const toggleLang = () => {
    setShowLangModal(true);
  };

  const handleLangChange = (value) => {
    let parsedQs = qs.parse(search);
    parsedQs.lang = value;
    props.history.push(`${pathname}?${qs.stringify(parsedQs)}`);
  };

  if (!routes && location.pathname !== "/404") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  if (location.pathname === "/404") {
    return null;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "center",
          height: "100%",
        }}
      >
        {routes && routes.length > 0 && (
          <AppTitle
            name={routes[0].psl_id}
            routes={routes}
            title={routesTitle[lang]}
            language={lang}
            redirectToHome={redirectToHome}
            toggleLang={toggleLang}
            currentTitle={currentTitle}
            showLang={showLang}
            setShowModal={setShowModal}
            courtName={courtName}
            court={rmbCourtSite.site ? "rmb" : court}
            overrideAppTitle={overrideAppTitle}
            message={message}
            themeColour={themeColour}
          />
        )}

        <DescriptionModal
          open={showModal}
          handleClose={() => setShowModal(false)}
          lang={lang}
          court={rmbCourtSite.site ? "rmb" : court}
          extraInstruction={extraInstruction}
          themeColour={themeColour}
        />
        <LanguageModal
          open={showLangModal}
          handleClose={() => setShowLangModal(false)}
          handleLangChange={handleLangChange}
          lang={lang}
          themeColour={themeColour}
        />
        <AnimatedSwitch
          atEnter={{ opacity: 0 }}
          atLeave={{ opacity: 0 }}
          atActive={{ opacity: 1 }}
          className="switch-wrapper"
        >
          {displayType && displayType === "routeNetwork" ? (
            <Route
              path="/:court/eta/:routeId/:routeSeq"
              render={(props) => (
                <RNEta
                  {...props}
                  lang={lang}
                  routes={routes}
                  court={rmbCourtSite.site ? "rmb" : court}
                  site={rmbCourtSite.site ? rmbCourtSite.site : site}
                  backFunc={redirectToHome}
                  setCurrentTitle={setCurrentTitle}
                  displayType={displayType}
                  routeNetwork={routeNetwork}
                  hideStop={hideStop}
                  trafficMessage={trafficMessage}
                  etaDisplayMethod={etaDisplayMethod}
                  showLicensePlate={showLicensePlate}
                />
              )}
            />
          ) : (
            <Route
              path="/:court/eta/:routeId/:routeSeq"
              render={(props) => (
                <Eta
                  {...props}
                  lang={lang}
                  routes={routes}
                  court={rmbCourtSite.site ? "rmb" : court}
                  site={rmbCourtSite.site ? rmbCourtSite.site : site}
                  backFunc={redirectToHome}
                  setCurrentTitle={setCurrentTitle}
                  displayType={displayType}
                  firstStopEtaRoutes={firstStopEtaRoutes}
                  fakeCircularRoutes={fakeCircularRoutes}
                  vehicleLocationAlwaysShow={vehicleLocationAlwaysShow}
                  overrideDepartureTimeRoutes={overrideDepartureTimeRoutes}
                  vehicleIconBearing={vehicleIconBearing}
                  hideStop={hideStop}
                  trafficMessage={trafficMessage}
                  etaDisplayMethod={etaDisplayMethod}
                  vehicleColor={vehicleColor}
                  stopColor={stopColor}
                  themeColour={themeColour}
                  showLicensePlate={showLicensePlate}
                  showLicensePlateOnMap={showLicensePlateOnMap}
                />
              )}
            />
          )}
          <Route
            path="/:court/schedule"
            render={(props) => (
              <Schedule
                {...props}
                lang={lang}
                routes={routes}
                court={rmbCourtSite.site ? "rmb" : court}
                setCurrentTitle={setCurrentTitle}
                isTodayHoliday={isTodayHoliday}
                isRA={displayType === "ra"}
                themeColour={themeColour}
              />
            )}
          />
          {displayType && displayType === "routeNetwork" ? (
            <Route
              path="/:court"
              render={(props) => (
                <RNHome
                  {...props}
                  lang={lang}
                  routes={routes}
                  court={rmbCourtSite.site ? "rmb" : court}
                  redirect={redirectToEta}
                  site={rmbCourtSite.site ? rmbCourtSite.site : site}
                  displayType={displayType}
                  setCurrentTitle={setCurrentTitle}
                  displayRouteCode={displayRouteCode}
                  routeNetwork={routeNetwork}
                />
              )}
            />
          ) : (
            <Route
              path="/:court"
              render={(props) => (
                <Home
                  {...props}
                  lang={lang}
                  routes={routes}
                  court={rmbCourtSite.site ? "rmb" : court}
                  redirect={redirectToEta}
                  site={rmbCourtSite.site ? rmbCourtSite.site : site}
                  displayType={displayType}
                  setCurrentTitle={setCurrentTitle}
                  displayRouteCode={displayRouteCode}
                  firstStopEtaRoutes={firstStopEtaRoutes}
                  fakeCircularRoutes={fakeCircularRoutes}
                  overrideDepartureTimeRoutes={overrideDepartureTimeRoutes}
                  themeColour={themeColour}
                />
              )}
            />
          )}
        </AnimatedSwitch>
        {!hideSchedulePage && !fromEClass && displayType !== "noETA" && routes?.length > 0 && (
          <NavBar
            lang={lang}
            site={rmbCourtSite.site ? rmbCourtSite.site : site}
            court={rmbCourtSite.site ? "rmb" : court}
            goToPage={navBarGoToPage}
            themeColour={themeColour}
          />
        )}
      </div>
    </MuiThemeProvider>
  );
};

export default withRouter(App);
